export default __webpack_public_path__ + "static/5-4a50bfea373893cd920720b7ca932353.png";